
import { Component, Inject, Vue } from 'vue-property-decorator';
import HelpBubble from './HelpBubbleComponent.vue';

@Component<LabelComponent>({ components: { HelpBubble } })
export default class LabelComponent extends Vue {
  @Inject({ default: '' })
  label!: string;
}
